<template>
    <div>
        <v-alert
            border="right"
            colored-border
            color="secondary"
            type="info"
            elevation="1"
        >
        {{ title }}
        <div style="min-height:10px;"></div>
        <ul>
            <li>{{ text1 }}</li>
            <li>{{ text2 }}</li>
            <li>{{ text3 }}</li>
        </ul>
        <div style="min-height:15px;"></div>
        {{ text4 }}
        </v-alert>
    </div>
</template>

<script>

export default {
    name: 'info-user-type-domacin',
    data: () => ({
        title: 'Kartico tipa »Domačin« lahko pridobi:',
        text1: "fizična oseba s stalnim prebivališčem v Občini Bled, katere vozilo je registrirano na naslovu v Občini Bled, kar mora ob vlogi tudi izkazati;",
        text2: "fizična oseba s stalnim prebivališčem v Občini Bled, ki uporablja službeno vozilo in za njegovo uporabo plačuje predpisano boniteto, kar izkaže v postopku izdaje parkirne dovolilnice;",
        text3: "fizična oseba s stalnim prebivališčem v Občini Bled, ki uporablja vozilo na podlagi pogodbe o lizingu ali pogodbe o poslovnem najemu.",
        text4: "Kartica tipa »Domačin« omogoča uporabo parkirišč in javnih sanitarij v lasti Občine Bled ter prehod skozi območja, kjer je to določeno s prometno signalizacijo (npr. Koritno, Mlino, Velika Zaka)."
    })
}

</script>